import { Text, Button, Link } from '@a0/quantum-web';
import PropTypes from 'prop-types';
import Logo from '../../shared/Logo';
import dictionary from '../dictionary';
import Chevron from '../icons/chevron';
import * as S from './styled';

const Mobile = ({ isMobileMenuOpen, toggleIsMobileMenuOpen, devHomeUrl }) => (
  <>
    <S.MobileTopWrapper>
      <a rel="external" arial-label="Homepage link" href={devHomeUrl}>
        <Logo alt="Auth0 Developer Logo" />
      </a>
      <S.BurgerIconWrapper
        onClick={toggleIsMobileMenuOpen}
        aria-label={isMobileMenuOpen ? 'Close' : 'Menu'}
        aria-expanded={isMobileMenuOpen}
      >
        <S.BurgerIcon isOpen={isMobileMenuOpen} />
      </S.BurgerIconWrapper>
    </S.MobileTopWrapper>
    <S.MobileWrapper
      isOpen={isMobileMenuOpen}
      role="navigation"
      aria-label="mobile-navigation"
    >
      {dictionary.sections.map((section) => (
        <S.MobileDetails key={section.text}>
          <S.MobileSummary>
            <Text type="Heading" size="xxsmall" margin="0" as="span">
              {section.text}
            </Text>
            <Chevron />
          </S.MobileSummary>
          {dictionary[section.id].map(
            (subsection) =>
              subsection.links && (
                <S.MobileSubMenu key={subsection.title}>
                  <S.MobileSubsectionTitle>
                    {subsection.title}
                  </S.MobileSubsectionTitle>
                  <S.MobileList>
                    {subsection.links.map((link) => (
                      <S.MobileListItem key={link.title}>
                        <Link size="large" href={link.url}>
                          {link.title}
                        </Link>
                      </S.MobileListItem>
                    ))}
                  </S.MobileList>
                </S.MobileSubMenu>
              ),
          )}
        </S.MobileDetails>
      ))}
      <S.CTAsWrapper>
        {dictionary.buttons.map((button) => (
          <Button
            buttonType={button.typeMobile}
            href={button.url}
            size="medium"
            arrow={button.typeMobile === 'primary'}
            key={button.text}
          >
            {button.text}
          </Button>
        ))}
      </S.CTAsWrapper>
    </S.MobileWrapper>
  </>
);

Mobile.propTypes = {
  isMobileMenuOpen: PropTypes.bool.isRequired,
  toggleIsMobileMenuOpen: PropTypes.func.isRequired,
  devHomeUrl: PropTypes.string.isRequired,
};

export default Mobile;
